export const showAccountStatus = userInfo => {
  const showStatus =
    userInfo &&
    "accountStatus" in userInfo &&
    (userInfo.accountStatus !== "Active" ||
      (userInfo?.billingLeftDays !== null && userInfo.billingLeftDays <= 30));

  return showStatus;
};
